var chunkToChildrenMap = {
	"1342": [
		6939
	],
	"1669": [
		8530
	],
	"2702": [
		1574
	],
	"5907": [
		6297
	],
	"6325": [
		8530,
		9862
	],
	"8633": [
		8295
	],
	"9188": [
		3121
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));